module.exports = __webpack_public_path__ + "static/media/pdf.0d109cbe.svg";